module.exports = __webpack_public_path__ + "img/logo.eb31d642.png";